import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { confirmBoostPayment } from './ManageListingsPage.duck';

const BoostSuccessPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const search = new URLSearchParams(useLocation().search);
  const sessionId = search.get('session_id');
  useEffect(() => {
    if (!sessionId) return;

    dispatch(confirmBoostPayment(sessionId))
      .then(() => history.push('/listings'))
      .catch(() => history.push('/listings'));
  }, [sessionId]);

  return <h2>Confirming boost payment…</h2>;
};

export default BoostSuccessPage;
